import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { AlertasCardService } from './alertas-card.service';
import { IAlertaPainelInterface } from '../shared/Util';
import { environment } from '../../environments/environment';
import { NgClass, NgIf, NgFor } from '@angular/common';
import { DataHorarioComponent } from '../shared/componentes/data-horario/data-horario.component';
import { PillAlertasComponent } from './componentes/pill-alertas/pill-alertas.component';


@Component({
    selector: 'app-alertas-card',
    templateUrl: './alertas-card.component.html',
    styleUrls: ['./alertas-card.component.css'],
    standalone: true,
    imports: [NgClass, NgIf, NgFor, DataHorarioComponent, PillAlertasComponent]
})
export class AlertasCardComponent implements OnChanges {
  @Input() isModal: boolean;
  @Input() dashboardResult = []
  @Output() abrirModalMapa = new EventEmitter<any[]>();  
  alertasNaoVisto: any;

  alertas: Array<IAlertaPainelInterface> = []
  urlOcorrencias = ''

  constructor(private alertasService: AlertasCardService) { }

  ngOnChanges(): void {
    this.consultaAlertas();    
  }


  async consultaAlertas(){
    let idsRoteiros = this.dashboardResult? this.dashboardResult.map((roteiro) => roteiro.IdRoteiro).join(',') : null
    if(idsRoteiros){
      this.alertas = await this.alertasService.getAlertas(idsRoteiros);
      this.alertasNaoVisto = this.alertas.filter((alerta) => !alerta.Visualizado);
    }   
  }

  async ocorrencia(alerta: IAlertaPainelInterface){
    this.urlOcorrencias = environment.url_telaOcorrencias + '/index.html' + window.location.search;
    let idRoteiroAlerta = btoa(alerta.RoteiroAlertaID.toString())
    this.urlOcorrencias = this.urlOcorrencias + '&opc5=' + idRoteiroAlerta;
    window.open(this.urlOcorrencias, "_blank");
  }


  abrirMapa(alerta: IAlertaPainelInterface){
    if(this.isModal){
      document.getElementById('btnCloseAlerta').click()
    }
    this.abrirModalMapa.emit([alerta.NumeroRoteiro, 0, {latitude: alerta.Latitude, longitude: alerta.Longitude}]);
  }

  marcaAlertaVisualizado(){
    let btnAlertaVisualizado = document.getElementById('marcarAlertaVisualizado') as HTMLButtonElement;
    if(btnAlertaVisualizado) {
      btnAlertaVisualizado.click();
    }
    else{
      console.log("botão com id=marcarAlertaVisualizado não encontrado")
    }
    setTimeout(() => this.consultaAlertas(), 1000);
  }
}
